import { render, staticRenderFns } from "./kfKPITable.vue?vue&type=template&id=32f465fe&scoped=true&"
import script from "./kfKPITable.vue?vue&type=script&lang=js&"
export * from "./kfKPITable.vue?vue&type=script&lang=js&"
import style0 from "./kfKPITable.vue?vue&type=style&index=0&id=32f465fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f465fe",
  null
  
)

export default component.exports